import styled from "@emotion/styled";
import React from "react";
import { compassColors } from "src/utils/styling";
import { FullWidth } from "../core/BodyLayout";
import { Text } from "src/components/core/Text";

type Props = {
  promoCode: string;
  percentageOff: number;
};

const Banner = styled.div`
  align-items: baseline;
  background-color: ${compassColors.mint};
  box-shadow: 0px 1px 0px ${compassColors.avocado};
  display: flex;
  flex-flow: row wrap;
  font-family: "Untitled Sans", sans-serif;
  font-size: 16px;
  font-weight: 400;
  justify-content: center;
  padding: 10px 20px;
  text-align: center;
  white-space: pre;
`;

export default function PromoBanner({ promoCode, percentageOff }: Props) {
  return (
    <FullWidth>
      <Banner>
        <Text
          i18nKey="promoBanner:copy"
          values={{ promoCode, percentageOff }}
          components={{
            BannerStrong: (
              <span style={{ fontSize: "18px", fontWeight: 500 }} />
            ),
          }}
        />
      </Banner>
    </FullWidth>
  );
}
